// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wizard-add-skill__form .skill-form__price-section {\n  left: 0;\n  width: 100%;\n}\n.wizard-add-skill__form .skill-form__price-title,\n.wizard-add-skill__form .skill-form__price-none {\n  text-align: center;\n}\n.wizard-add-skill__form .skill-form__price-none {\n  max-width: 370px;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
